import axios from 'axios';
import {
  IPropertyCollection,
  IPropertyListParams,
  ICreatePropertyPayload,
  IDeletePropertyPayload,
  IProperty,
  IUpdatePropertyPayload,
  IPropertyListByCategoryPayload,
} from 'entities/Property/Property.models';

const basePath = 'property';

export const propertyTransport = {
  get: (params: IPropertyListParams): Promise<IPropertyCollection> => axios.get(`${basePath}`, { params }),
  getByCategory: (payload: IPropertyListByCategoryPayload): Promise<IPropertyCollection> =>
    axios.post(`${basePath}/by-category`, payload),
  create: (payload: ICreatePropertyPayload): Promise<IProperty> => axios.post(`${basePath}`, payload),
  update: (payload: IUpdatePropertyPayload): Promise<IProperty> => axios.patch(`${basePath}`, payload),
  delete: (payload: IDeletePropertyPayload): Promise<IProperty> => axios.delete(`${basePath}`, { data: payload }),
};
